<script setup>
    import { close_button_ui_styles, modal_ui_styles } from '@/utilities/ui';
    const { $bus } = useNuxtApp();

    const open = defineModel('open');
    const nextStep = defineModel('nextStep');
    const router = useRouter();
    const route = useRoute();

    watch(open, (val) => {
        if (val) {
            $bus.emit('drawer-open');
        } else {
            $bus.emit('drawer-close');
            const currentQuery = { ...route.query };
            delete currentQuery.modal;
            router.replace({ query: currentQuery });
        }
    });
</script>

<template>
    <UModal
        v-model:open="open"
        title="Save a Seat"
        :ui="modal_ui_styles"
        :dismissable="false"
        :close="close_button_ui_styles"
        class="reservations-modal">
        <template #body>
            <div class="flex flex-col items-center justify-center inner">
                <h1 class="h1">Seat reservations aren't open yet!</h1>
                <div class="warning-banner">
                    <UIcon name="local-warning" class="warning-icon" />
                    <p>
                        This session has a limited number of seats available. Seat reservations will open on August 5th for VIP pass holders and on August 12th for General Admission pass holders. Please check back then to reserve your seat!
                    </p>
                </div>
                <UButton label="Close" variant="outline-close" @click="open = false" />
            </div>
        </template>
    </UModal>
</template>

<style lang="scss" scoped>
    .reservations-modal {
        color: var(--teal-13);

        .inner {
            max-width: 41.875rem;
            padding-bottom: 2.5rem;

            h1 {
                text-align: center;
                font-size: 2rem;
                font-style: normal;
                font-weight: 500;
                line-height: 2.5rem;
                letter-spacing: -0.04rem;
                margin-bottom: 2rem;
            }

            .warning-icon {
                width: 1.5rem;
                height: 1.5rem;
                flex-shrink: 0;
            }

            .warning-banner {
                background-color: var(--orange-ghost);
                border-radius: var(--radius);
                padding: 1.8125rem;
                color: var(--orange-ghost-dark);
                font-size: 0.875rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.25rem;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                margin-bottom: 2.8125rem;
                letter-spacing: 0;

                @media (min-width: $tablet) {
                    flex-direction: row;
                    align-items: center;
                    gap: 1.644375rem;
                }
            }
        }
    }
</style>
